// src/styles.ts
var typographySx = ({
  fontWeight,
  bold
}) => ({
  fontWeight: String(fontWeight || (bold ? 700 : 400))
});

export {
  typographySx
};
